import type { BatchEditSelectOptionProps } from "./batch-edit-select-option.type";

import { Tooltip } from "antd";

const BatchEditSelectOption = <Value = string,>({
  option,
}: BatchEditSelectOptionProps<Value>) => {
  const { tooltip, label } = option;

  if (!tooltip) return label;

  return <Tooltip title={tooltip}>{label}</Tooltip>;
};

export default BatchEditSelectOption;
